import * as React from 'react';
import styled from 'styled-components';

import { focusOutline, media } from '../../../styles/mixins';
import { RemixIcon } from '../../shared/remix-icon';

type Props = {
	prevRef: React.Ref<HTMLButtonElement>;
	nextRef: React.Ref<HTMLButtonElement>;
	prevRemix: string;
	nextRemix: string;
	isEnabled: boolean;
};

export const BlogNavigationButton = ({
	prevRef,
	nextRef,
	prevRemix,
	nextRemix,
	isEnabled,
}: Props) => {
	return (
		<>
			<NavigationButton
				aria-label="Previous slides"
				data-direction="prev"
				ref={prevRef}
				data-enabled={isEnabled}
			>
				<ButtonRemixIcon className={prevRemix} />
			</NavigationButton>
			<NavigationButton
				aria-label="Next slides"
				data-direction="next"
				ref={nextRef}
				data-enabled={isEnabled}
			>
				<ButtonRemixIcon className={nextRemix} />
			</NavigationButton>
		</>
	);
};

const NavigationButton = styled.button`
	--size: 48px;

	position: absolute;
	bottom: -92px;

	&[data-enabled='false'] {
		display: none;
	}

	&[data-direction='prev'] {
		right: calc(var(--size) + 24px);
	}

	&[data-direction='next'] {
		right: 0;
	}

	display: none;
	flex-direction: row;
	align-items: center;
	padding: 12px;
	gap: 4px;

	width: var(--size);
	height: var(--size);

	background: transparent;

	border: 1px solid ${(p) => p.theme.gradients.gray5};
	border-radius: 100px;
	cursor: pointer;
	transform: translateY(-50%);

	&:focus-visible,
	&:hover {
		&:after {
			background-size: 100% 100%;
		}
	}

	&:focus-visible {
		${focusOutline()};
	}

	${media.lg`
		display: block;
	`};

	${media.xxl`
    --size: 21px;

    top: -40px;

    width: var(--size);
	  height: var(--size);

    padding: 0;
    border: none;

    &[data-direction='prev'] {
      right: calc(var(--size) + 26px);
    }
  `}
`;

const ButtonRemixIcon = styled((props) => <RemixIcon {...props} />)`
	font-size: 24px;
	line-height: 24px;

	color: ${(p) => p.theme.gradients.gray5};
`;
